import React, { forwardRef } from 'react';
import AdminCustomURLCopy from './AdminCustomURLCopy';
import MessageBox from './MessageBox';
import { IoImagesOutline } from 'react-icons/io5';
import MessageLabel from './MessageLabel';
import AdminDownloadFile from './AdminDownloadFile';
import { IoMdInformationCircle } from "react-icons/io";
import FormContainer from './FormContainer';

const AdminImageUploadZone = forwardRef(({ id, onChange, selectedFile, uploadedImage, onDelete, name, previewFalse, accept, error, icon, idAttribute, imguploaded, mail_logos, apiFieldName, orientationSlug, enableCropping, ...rest }, ref) => {

    return (
        <div className="text-start my-2 pb-3">

            <FormContainer className={`gap-5 my-3`}>
                {id && !previewFalse && uploadedImage && (
                    <img
                        src={uploadedImage}
                        alt="Image"
                        className={`rounded-2 ${imguploaded ? "w-50 h-50" : "w-25 h-50"}`}
                    />
                )}
                {selectedFile && (
                    <>
                        {(accept !== "text/vtt" && accept !== ".xlsx" && accept !== "application/pdf") && (
                            <div className="imagedropcopy text-end position-relative w-25 h-50">
                                <img ref={ref} src={URL.createObjectURL(selectedFile)} alt="Uploaded" className="thumbnails-upload-images rounded-2 h-100" />
                                <button id="clearFile" onClick={() => onDelete(name)} type="button" className="btn-close mx-auto image-close rounded-circle opacity-1 shadow theme-bg-color" ></button>
                            </div>
                        )}
                        {(accept == "text/vtt" || accept == "text/srt" || accept === ".xlsx" || accept === "application/pdf") && (

                            <div className="position-relative d-flex align-items-center px-3 py-2 rounded-2 shadow ">
                                <MessageLabel text={selectedFile.name} noMargin />
                                <button id="clearFile" onClick={() => onDelete(name)} type="button" className="btn-close mx-auto  rounded-circle opacity-1 shadow theme-bg-color" ></button>
                            </div>
                        )
                        }
                    </>
                )}
                <div className={`ImageUploadContainer imagedrop ${orientationSlug || ""} ${error && 'custom-input-error'}`} >
                    <input
                        type="file"
                        name={name}
                        ref={ref}
                        onChange={onChange}
                        accept={!accept ? "image/*" : accept}
                        style={{ opacity: '0' }}
                        className='w-100 h-100 AdminImageUploader'
                        key={selectedFile ? "yes" : "no"}
                        id={idAttribute ? idAttribute : id ? id : "fileId"}
                        data-test-id={idAttribute ? idAttribute : (id ? id : "fileId")}
                        data-apifield={apiFieldName || undefined}
                        data-orientation={orientationSlug || undefined}
                        data-enable-cropping={enableCropping === true ? '1' : enableCropping === false ? '0' : undefined}
                        {...rest}
                    />
                    <label className='position-absolute top-50 start-50 translate-middle mb-0' style={{ pointerEvents: "none", zIndex: 2 }}>
                        {icon ? (React.isValidElement(icon) ? React.cloneElement(icon, { style: { width: "24px", height: "24px", color: "inherit" } }) : icon) : <IoImagesOutline size={24} color="#6c757d" />}
                    </label>
                </div>
            </FormContainer>

            {error && (<div className='d-flex align-items-center gap-1 mt-3'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${error}`} classname='errorred  d-block' /></div>)}
            {id && previewFalse && uploadedImage && <AdminDownloadFile name="Uploaded File" value="yes" link={uploadedImage} className={"mb-3"} />}
            {uploadedImage && <AdminCustomURLCopy link={uploadedImage} fieldName={""} className="copy-board-input" labelClassName="mt-md-2" />}

        </div>
    );
});

export default AdminImageUploadZone;
